import React, { useEffect, useRef, useState } from "react";
import { AiFillGithub, AiOutlineLink } from "react-icons/ai";
import { MdPictureAsPdf } from "react-icons/md";
import "./Timeline.css";

function TimelineItem({ item, index }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const [lightbox, setLightbox] = useState(null); // 当前放大的图片 src
  const isRight = index % 2 !== 0;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.05 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  // 按 ESC 关闭
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") setLightbox(null); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  return (
    <>
      <div
        ref={ref}
        className={`timeline-item ${isRight ? "right" : ""} ${visible ? "visible" : ""}`}
      >
        {/* 中央圆点 + 年份 */}
        <div className="timeline-dot">
          <span className="timeline-year">{item.year}</span>
        </div>

        {/* 卡片 */}
        <div className="timeline-card">
          {item.images && item.images.length > 0 ? (
            <div className="timeline-card-images">
              {item.images.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt={`${item.title} ${i + 1}`}
                  className="timeline-card-img timeline-card-img--clickable"
                  onClick={() => setLightbox(src)}
                />
              ))}
            </div>
          ) : (
            item.image && (
              <img
                src={item.image}
                alt={item.title}
                className="timeline-card-img timeline-card-img--clickable"
                onClick={() => setLightbox(item.image)}
              />
            )
          )}

          {(item.institution || item.supervisor) && (
            <p className="timeline-meta">
              {item.institution && <span>🏫 {item.institution}</span>}
              {item.institution && item.supervisor && <span> · </span>}
              {item.supervisor && <span>导师：{item.supervisor}</span>}
            </p>
          )}

          <h3 className="timeline-card-title">{item.title}</h3>
          <p className="timeline-card-desc">{item.description}</p>

          {item.tech && item.tech.length > 0 && (
            <div className="timeline-tags">
              {item.tech.map((t, i) => (
                <span key={i} className="timeline-tag">{t}</span>
              ))}
            </div>
          )}

          <div className="timeline-links">
            {item.github && (
              <a href={item.github} target="_blank" rel="noreferrer" className="timeline-link-btn">
                <AiFillGithub /> GitHub
              </a>
            )}
            {item.demo && (
              <a href={item.demo} target="_blank" rel="noreferrer" className="timeline-link-btn">
                <AiOutlineLink /> Demo
              </a>
            )}
            {item.paper && (
              <a href={item.paper} target="_blank" rel="noreferrer" className="timeline-link-btn">
                <MdPictureAsPdf /> 论文
              </a>
            )}
            {item.arxiv && (
              <a href={item.arxiv} target="_blank" rel="noreferrer" className="timeline-link-btn">
                <AiOutlineLink /> arXiv
              </a>
            )}
          </div>
        </div>
      </div>

      {/* Lightbox 弹窗 */}
      {lightbox && (
        <div className="lightbox-overlay" onClick={() => setLightbox(null)}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={() => setLightbox(null)}>✕</button>
            <img src={lightbox} alt="preview" className="lightbox-img" />
          </div>
        </div>
      )}
    </>
  );
}

export default TimelineItem;
